import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const AuditLogsPage = lazy(() =>
  import('@/pages/ads/audit-logs/audit-logs-page').then((m) => ({
    default: m.AuditLogsPage,
  })),
);

export const Route = createFileRoute('/_app/ads/audit-logs')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:audit-log', '/ads/dashboard'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <AuditLogsPage />
    </Suspense>
  ),
});
